<button mat-icon-button (click)="getProductDetails()">
    <mat-icon>info</mat-icon>
</button>
